export default __webpack_public_path__ + "static/media/mail_grün.fb4c7587.png";